import React, { Component } from 'react';
import { GlobalContext } from '../global-context.js';
import Search from '../parts/userSearch';
import Styles from '../Styles.js';

class ProjectListContainer extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            projects: null
        };
    }

    async getProjects() {
      const { devmode, setGlobalError } = this.context;
      let res = await fetch(`/api/projects`)
      if (res.ok) {
          const p = await res.json();
          const projects = p.projects ? p.projects : []
          devmode && console.log("Projects:", projects)
          this.setState({
              projects
          });
          return
      }
      const errdata = await res.json();
      const message = `error ${res.status} fetching projects list: ${errdata.message}`;
      console.log(message);
      setGlobalError(message);
    }

    async update() {
        const { userQuery } = this.context;
        if (userQuery !== null) {
          return;
        }
        else {
          this.getProjects();
        }
    }

    componentDidMount() {
        this.update();
    }

    render() {
        const { navigate } = this.props;
        const { projects } = this.state;
        const { config, person, userQuery, updateUserQuery } = this.context;

        let currentProjects = userQuery && userQuery.projects ? userQuery.projects : projects;

        if (!currentProjects) {
            return null
        }

        const logs = userQuery && userQuery.logs ? userQuery.logs : [];

        let plist = <h2>(no projects found)</h2>
        if (currentProjects && currentProjects.length && !userQuery) {
            plist = <div>
                {currentProjects.map((project) => {
                    const pstate = project.state ? project.state : 0;
                    const ltext1 = `Project ${project.id}, ${config.project_states[pstate]}:`
                    return (
                        <div onClick={() => navigate(`project/${project.id}`)}
                          key={project.title + project.id}
                          style={{cursor: "pointer", marginTop: "25px"}}>
                          <h4>{ltext1}</h4>
                          <h3>{project.title}</h3>
                          <h4>{project.pi_display_name} / {project.principal_investigator}</h4>
                        </div>
                    );
                })}
            </div>
        }
        else if (currentProjects && currentProjects.length && userQuery) {
          plist = <div>
            {currentProjects.map((project) => {
                const pstate = project.project_state ? project.project_state : 0;
                const ltext1 = `${project.role}: ${project.title}`
                const ltext2 = `(State: ${config.project_states[pstate]})`;
                return (
                    <div onClick={() => {
                      navigate(`project/${project.id}`);
                      updateUserQuery(null);
                    }}
                      key={project.title + project.id}
                      style={{cursor: "pointer", marginTop: "25px"}}>
                      <h3>{ltext1}</h3>
                      <h4>{ltext2}</h4>
                    </div>
                );
            })}
          </div>
        }

        const logslist = <div className="logs">
          {
              logs.map(entry => {
                  return (
                      <div key={entry.time_stamp}
                        className="log-entries">
                          <div className="log-entry">
                            <div className="log-label">User</div>
                            <div className="log-value">{entry.log_user}</div>
                          </div>
                          <div className="log-entry">
                            <div className="log-label">Message</div>
                            <div className="log-value">{entry.message}</div>
                          </div>
                          <div className="log-entry">
                            <div className="log-label">Time</div>
                            <div className="log-value">{entry.time_stamp.split(" ")[0]}</div>
                          </div>
                      </div>
                  );
              })
          }
        </div>

        return (
          <Styles>
            <h1 style={{marginTop: "45px"}}>{userQuery ? `User: ${userQuery.display_name}` : `All Projects`}</h1>
            {person.roles && person.roles.length > 0 && <Search />}
            {userQuery && <h2 className="search-headers">Projects</h2>}
            <div className="projects">
              {plist}
            </div>
            {logs.length > 0 && <h2 className="search-headers">Logs</h2>}
            <div className="logs">
              {logslist}
            </div>

          </Styles>
        );
    }
}

export default ProjectListContainer;
